import React from 'react'

function DiscountButton() {
    return (
        <>
            <a href='#' id='DiscountButton' type='button' 
            className="btn btn-sm btn btn-bg product-view-button discount-btn"> More View</a>
        </>
    )
}

export default DiscountButton;
